import loadable from '@loadable/component';

export const NewsList = loadable(/* #__LOADABLE__ */ () => import('./NewsList'));
